﻿import { get, post } from './api-client';

export const wishlistService = {
    getHeaderLinks: () => get('/wishlist/getHeaderLinks'),

    getQuote: () => get('/wishlist/wishlist'),

    updateQuote: (formData) => post('/wishlist/updateWishlist', formData),

    requestQuote: (model) => post('/wishlist/requestQuote', model),

    getQuotesHistory: () => get('/wishlist/getQuotes'),

    getQuoteById: (quoteId) => get(`/wishlist/getQuote/${quoteId}`)
};